<template>
    <ubi-page-container wide-main-content>
        <template v-slot:page-actions>
            <div class="text-center">
                <el-button type="primary" @click="repartitionAuto()">
                    {{ $t("quotas.repartitionQuotas") }}
                </el-button>
            </div>
        </template>
        <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
        <ubi-panel>
            <div class="panel-quota">
                <p class="text-center">
                    {{ $t('quotas.txtPresentationQuota') }}
                </p>
            </div>
            <div v-if="listeUsersPortailsQuotas" class="panel-quota-list">
                <el-table :data="listeUsersPortailsQuotas" style="width: 100%">
                    <el-table-column :label="$t('quotas.portails')" fixed min-width="150">
                        <template v-slot="{ row: portail }">
                            <el-link
                                  :href="portail.portalUrlUbiflow"
                                  target="_blank" rel="noopener">
                                    {{portail.portalName}}
                            </el-link>
                        </template>
                    </el-table-column>
                  <el-table-column :label="$t('quotas.max')" fixed min-width="80">
                    <template v-slot="{ row: portail }">
                      {{portail.portalNbAnnoncesQuota}}
                    </template>
                  </el-table-column>
                    <el-table-column :label="$t('quotas.total')" fixed min-width="120">
                        <template v-slot="{ row: portail }">
                          <span v-bind:style="getStyleTotal(portail.usersQuotas)">
                            {{getTotal(portail.usersQuotas)}}
                            <el-tooltip placement="top-start">
                              <div slot="content">{{ $t('quotas.tooltipsTotalQuotas') }}</div>
                              <em class="el-icon-question"></em>
                            </el-tooltip>
                          </span>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(user, ind) in listUsers" :label="user.fullname" :key="user.id" min-width="150">
                        <template v-slot="{ row: portail }">
                          <el-input v-model.number="portail.usersQuotas[ind].userQuota" v-if="user.id">
                              <template slot="prepend">
                                <span v-bind:style="getStyle(portail.usersQuotas[ind].userPosts,portail.usersQuotas[ind].userQuota)">
                                    {{ portail.usersQuotas[ind].userPosts }}
                                </span>
                              </template>
                          </el-input>
                          <div v-else class="el-input__inner" style="text-align: center; background-color: #F5F7FA; color: #909399;">{{ portail.usersQuotas[ind].userPosts }}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <p class="btn-update-quotas" v-if="updateBloque">
                    <el-tooltip effect="dark" :content="$t('portals.broadcast.overMessageQuota')" placement="top">
                        <el-button type="primary" @click="updateAllQuotas()">
                            {{ $t("quotas.validerQuotas") }}
                        </el-button>
                    </el-tooltip>
                </p>
                <p class="btn-update-quotas" v-else>
                    <el-button type="primary" @click="updateAllQuotas()" >
                        {{ $t("quotas.validerQuotas") }}
                    </el-button>
                </p>
            </div>
            <div v-else class="txtAucunQuota">
                <p>{{ $t("quotas.txtAucunQuota") }}</p>
            </div>
        </ubi-panel>
        </div>
    </ubi-page-container>
</template>

<script>
import { getUsersPortailsQuotas, updateQuotas } from '@/services/portals'
import { mapGetters } from 'vuex'
import { $t } from '@/i18n'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'Quota',
  components: { UbiPanel, UbiPageContainer },
  data () {
    return {
      loading: true,
      listeUsersPortailsQuotas: [],
      listUsers: [],
      updateBloque: false,
      portailsBloque: []
    }
  },
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin', 'isSubUser']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    getStyle (userPosts, userQuota) {
      if (userPosts > userQuota) {
        return 'color: red;font-weight: bold;'
      } else {
        return ''
      }
    },
    getStyleTotal (usersQuotas) {
      let quotaPosts = 0
      let quotaUser = 0
      for (const user of usersQuotas) {
        quotaUser += user.userQuota ? user.userQuota : 0
        quotaPosts += user.userPosts ? user.userPosts : 0
      }
      return this.getStyle(quotaPosts, quotaUser)
    },
    getTotal (usersQuotas) {
      let quotaPosts = 0
      let quotaUser = 0
      for (const user of usersQuotas) {
        quotaUser += user.userQuota ? user.userQuota : 0
        quotaPosts += user.userPosts ? user.userPosts : 0
      }
      this.checkUpdateBloque()
      return quotaPosts + ' / ' + quotaUser
    },
    checkUpdateBloque () {
      for (const portail of this.listeUsersPortailsQuotas) {
        let quotaUser = 0
        for (const user of portail.usersQuotas) {
          quotaUser += user.userQuota ? user.userQuota : 0
        }
        if (quotaUser > portail.portalNbAnnoncesQuota) {
          this.updateBloque = true
          return
        }
      }
      this.updateBloque = false
    },
    // Récupérer les portails actifs et users en promise
    async loadData () {
      this.loading = true
      await getUsersPortailsQuotas()
        .then((res) => {
          this.listeUsersPortailsQuotas = res
        }).catch(() => {
          this.$message({
            type: 'error',
            message: $t('components.lists.errorOnLoading')
          })
        }).finally(() => {
          this.loading = false
        })
      // Construction de la liste des users
      const users = []
      for (const portail of this.listeUsersPortailsQuotas) {
        portail.usersQuotas.sort((m1, m2) => {
          if (!m1.userId) return 1
          if (!m2.userId) return -1
          return m1.userFullName.localeCompare(m2.userFullName)
        })
        for (const user of portail.usersQuotas) {
          users.push({ id: user.userId, fullname: user.userFullName })
        }
      }
      // Dédoublonnage
      this.listUsers = [...new Map(users.map(item => [item.id, item])).values()]
      this.loading = false
    },
    async updateAllQuotas () {
      this.loading = true
      if (this.updateBloque) {
        window.scrollTo(500, 0)
        this.$message({ message: this.$t('portals.broadcast.overMessageQuota'), type: 'error' })
        this.loading = false
      } else {
        // génération data pour update quota
        const updateData = []
        for (const portailData of this.listeUsersPortailsQuotas) {
          for (const quotasData of portailData.usersQuotas) {
            updateData.push({ user: quotasData.userId, portail: portailData.diffusionId, quota: quotasData.userQuota })
          }
        }
        const response = await updateQuotas(updateData)
        if (response.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
          this.loading = false
          return false
        } else {
          this.$message({ message: this.$t('quotas.succesUpdate'), type: 'success' })
          this.loading = false
        }
      }
    },
    repartitionAuto () {
      for (const portailData of this.listeUsersPortailsQuotas) {
        const portailQuotaAuto = Math.floor(portailData.portalNbAnnoncesQuota / portailData.usersQuotas.length)
        for (const userData of portailData.usersQuotas) {
          userData.userQuota = portailQuotaAuto
        }
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
    .panel-quota {
       margin-left: 4%;
       margin-right: 4%;
       font-size: 130%;
      p{
        text-align: center;
      }
    }

    .panel-quota-list{
      margin-top: 10px;
      .btn-update-quotas{
        text-align: center;
      }
    }
    .txtAucunQuota {
      text-align: center;
      p{
        font-size: 12px;
        font-weight: 500;
        color: #21b1be;
      }
    }
</style>
